import { IGenericResponse } from "src/apis/helpers/baseModels/IGenericResponse";
import { Api } from "src/apis/helpers/configs/api";
import { ProjectsDto } from "src/data/models/projectsDtos/projectsDto.interface";
import BaseRepository from "../Base/BaseRepository";
import IProjectsRepository from "./IProjectsRepository";

export default class ProjectsRepository extends BaseRepository implements IProjectsRepository {

  async getProjects(): Promise<IGenericResponse<Array<ProjectsDto>>> {

    const result = this.CreateRequestBuilder()

    const request = result
      .setMethod('get')
      .setUrl(Api.Projects.getProjects)

    return await request
      .GetResultAsync();
  }
  async addProjects(body: ProjectsDto): Promise<IGenericResponse<ProjectsDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('post')
      .setBody(body)
      .setUrl(Api.Projects.addProjects)

    return await request
      .GetResultAsync()
  }
  async editProjects(body: ProjectsDto): Promise<IGenericResponse<ProjectsDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('put')
      .setBody(body)
      .setUrl(Api.Projects.editProjects)

    return await request
      .GetResultAsync();
  }

  async deleteProjects(projectId: number): Promise<IGenericResponse<number>> {
    const request = this.CreateRequestBuilder()
      .setMethod('delete')
      .setUrl(Api.Projects.deleteProjects, { projectId })

    return await request
      .GetResultAsync()
  }



}
